import React, { useEffect, useState } from 'react'
import Layout from "../components/Layout";
import { motion } from "framer-motion";
import {
  staggerContainer,
} from "../utils/motion";
import styles from "../styles";
import { Footer, Navbar } from "../components";
import Button from "../components/common/Button";
import { BgGradient } from "../assets";
import Insights from "../sections/Insights";
import LeadingBuilders from '../sections/LeadingBuilders';



const HowItsWork = () => {
  
  const [showFloatHeader, setShowFloatHeader] = useState(false)
  const [showSideBar, setShowSideBar] = useState(false)

 

  useEffect(() => {
    document.getElementById('layout').addEventListener('scroll', () => {
      document.getElementById('layout').scrollTop > 50 ? setShowFloatHeader(true) : setShowFloatHeader(false);
    })
  })



  return (
    <Layout id="layout" showFloatHeader={showFloatHeader} showSideBar={showSideBar} setShowSideBar={setShowSideBar}>

      <div
        style={{ backgroundImage: `url(${BgGradient})` }}
        className="bg-no-repeat bg-cover">

        <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

        <section className={`${styles.yPaddings} w-full bg-cover `}>
          <motion.div
            variants={staggerContainer}
            initial=""
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            className={`${styles.innerWidth} relative w-4/5  mx-auto pb-6 flex flex-col-reverse xl:flex-row`}>

            <div className="w-full px-10 lg:px-14 mt-8 xl:mt-14 mx-auto flex items-start justify-start ">
              <div className="flex flex-col items-start space-y-6">
                <h1 className="text-[50px] lg:text-[88px] font-Poppins tracking-normal text-black xl:leading-snug">
                  How it works
                </h1>
                <p className="w-full lg:w-4/5 text-sm lg:text-lg font-Poppins tracking-normal text-font_primary xl:leading-snug">
                  It is as simple as how you would use Whatsapp. With Realiti.io it just take three simple stepsto get your real estate business up and running…
                </p>
                <div className="flex flex-row space-x-4">
                  <Button text="Sign Up" to="/" />
                </div>
              </div>
            </div>

          </motion.div>
        </section>

      </div>

      <div className="relative">
        <LeadingBuilders />
        <Insights />
      </div>
      <Footer />
    </Layout>
  );
};

export default HowItsWork;
